import React, {Component} from 'react';
import {Route,Switch} from 'react-router-dom';
import './App.css';
import Home from "./components/main-home/home.component";
import Card from "./components/main-card/card-container/card-container.component";
import Gallery from "./components/main-gallery/gallery-container/gallery-container.component";
import AboutUs from "./components/main-about-us/about-us.component";
import {Nav} from "./components/navigation/nav.component";
import FooterComponent from "./components/navigation/footer.component";
import SignIn from "./components/main-authentication/sign-in/sign-in.component";
import SignUp from "./components/main-authentication/sign-up/sign-up.component";

class App extends Component {
  render() {
    return (
      <div className="main-bg-custom">
        < Nav/>
        <div className="content">
          <Switch>
              <Route path="/posts" component={Card}/>
              <Route path="/gallery" component={Gallery}/>
              <Route path="/about-us" component={AboutUs}/>
              <Route path="/sign-in" component={SignIn}/>
              <Route path="/sign-up" component={SignUp}/>
              <Route path="/" component={Home}/>
          </Switch>
        </div>
        <FooterComponent/>
      </div>
    );
  }
}

export default App;
